import React from "react";
import {DropDownList} from "controls/react/kendoWrappers/dropDownList";
import {CeeViewDataSource} from "tools/ceeViewDataSource";
import {AssetAPI} from "tools/apis/assetAPI";
import {ErrorHandler} from "core/errorHandler";
import {translator} from 'core/localization/localization';
import {AddAsset} from "controls/react/windows/addAsset";
import {inputWithAction} from 'controls/react/form/common';
import withRequired from 'controls/react/dropdowns/withRequired';
import Configuration from 'configuration'

const i = translator({
  "Select Asset...": {
    "no": "Velg ressurs...",
    "en": "Select asset..."
  },
  "Select...": {
    "no": "Velg..."
  }
});

//kendo drop down does not work properly if value is an empty string so we set this value instead
export const EmptyItemValue = 'e712c36e-7e7b-4877-a3d4-806782617497';

export class AssetDropDown extends React.PureComponent {
	constructor(props) {
		super(props);
		const sharedAgents = this.props.sharedAgents ?? Configuration.installedMonitorSettings[this.props.monitorType]?.sharedAgents;
		const placeholder = this.props.placeholder === undefined ? this.props.isTypeAgent ? i('Select...') : i('Select Asset...') : this.props.placeholder

		this.config = {
			dataSource: AssetDropDown.getDataSource(this.props.accountId,
				this.props.includeSubaccounts,
				this.props.isTypeAgent,
				this.props.systemType,
				sharedAgents,
				props.emptyItem),
			dataTextField: 'name',
			dataValueField: props.dataValueField ?? 'id',
			suggest: false,
			placeholder: placeholder,
			autoBind: true
		};
	}

	static getDataSource(accountId, includeSubaccounts, isTypeAgent, systemType, sharedAgents, emptyItem) {
		return new CeeViewDataSource({
			transport: {
				read: {
					url: isTypeAgent ? AssetAPI.getAssetAgentsUrl(accountId, includeSubaccounts, systemType, sharedAgents) : AssetAPI.getAssetsUrl(accountId, includeSubaccounts),
					contentType: 'application/json; charset=utf-8',
					type: 'GET',
					dataType: 'json',
					cache: false
				}
			},
			schema: {
				data: function(response) {
					response.forEach(x => {
						if (x.shared) {
							x.name += ' (*)';
						}
					});

					if(emptyItem){
						response.splice(0, 0, {
							name: emptyItem,
							id: EmptyItemValue
						})
					}

					return response;
				}
			},
			error: ErrorHandler.kendoServerError
		});
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.accountId !== this.props.accountId) {
			this.kendoRef.setDataSource(AssetDropDown.getDataSource(this.props.accountId, this.props.includeSubaccounts, this.props.isTypeAgent, this.props.systemType, this.props.sharedAgents))
		}
	}
	onCreateNew = (newAssetId) => {
		this.kendoRef.dataSource.read().then(()=>{
			this.kendoRef.value(newAssetId);
			this.props.onChange(newAssetId);
		})
	}
	render() {
		let {config, combo, canAdd, isTypeAgent, onInfoChanged, onChange, ...others} = this.props;

		canAdd = !isTypeAgent && (canAdd ?? true);

		return <div className={inputWithAction()}>
			<DropDownList config={this.config}
			              containerClass={inputWithAction('input')}
			              kendoRef={(ref) => this.kendoRef = ref}
			              combo={true}
			              autoBind={true}
						  type='asset'
			              onChange={onChange}
						  onInfoChanged={onInfoChanged}
						  {...others}/>
			{canAdd && <AddAsset onClose={() => this.kendoRef.dataSource.read()}
								 accountId={this.props.accountId}
								 containerClass={inputWithAction('action')}
								 disabled={this.props.disabled}
								 identifier={this.props.identifier}
								 onCreateNew={this.onCreateNew}
			/>}
		</div>

	}
}

export default withRequired(AssetDropDown);
